
import { Component, Vue, Emit } from "vue-property-decorator";
import { Branding } from "./helper";

export interface EnvironmentConfig {
  environment: string;
}

@Component({})
export default class SignUp extends Vue {
  public loading: boolean = false;

  public get environmentClass() {
    return environment();
  }

  public get appClass() {
    const branding = Branding.getBranding();
    let obj = {
      [this.environmentClass]: true,
    };
    if (branding) {
      obj[branding] = !!branding;
    }
    return obj;
  }
}

export function environment() {
  const envConfig = window["envConfig"] as EnvironmentConfig;
  return envConfig.environment;
}

export function apiURL() {
  return "https://signupapi.prospect365" + domainSuffix() + ".com";
}

export function domainSuffix() {
  let suffix: string;
  switch (environment()) {
    case "li":
      suffix = "";
      break;
    case "qa":
      suffix = "-qa";
      break;
    default:
      suffix = "-dev";
  }
  return suffix;
}
